module.exports = __webpack_public_path__ + "static/blog_image-a6f1c16c90b88ee81907ad1a176b011e.jpg";